import { computed } from 'vue';

export const useScreen = () => {
    const nuxtApp = useNuxtApp();
    const screen = nuxtApp.$screen;

    if (!screen) {
        throw new Error('The screen plugin is not initialised. Make sure app/plugins/screen.client.ts is loaded.');
    }

    const isDesktop = computed(() => !screen.isMobile.value);

    return {
        breakpoint: screen.breakpoint,
        width: screen.width,
        isMobile: screen.isMobile,
        isDesktop,
    };
};

